<template>
  <div>
    <div class="main-title">驾校列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
              <el-button type="primary" @click="addSchool()">添加驾校</el-button>
            </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索驾校名称"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="name"
          label="驾校简称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="fullname"
          label="驾校全称"
          width="350">
        </el-table-column>
        <!--
        <el-table-column
          prop="contact"
          label="驾校联系人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系电话"
          width="120">
        </el-table-column>
        -->
        <el-table-column
          prop="address"
          label="地址"
          width="550">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.group_id != 0" @click="updateSchool(scope.row)">修改</el-button>
            <el-button type="text" v-if="scope.row.group_id != 0" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 驾校信息弹出框 -->
    <el-dialog :title="updateSchoolTitle" :visible.sync="updateSchoolVisible">
      <el-form :model="schoolForm" ref="schoolForm" :rules="schoolFormRules" label-width="200px">
        <el-form-item prop="name" label="驾校简称" v-if="modelType === 'add'">
          <el-input v-model="schoolForm.name" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="驾校全称">
          <el-input v-model="schoolForm.fullname" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="法人">
          <el-input v-model="schoolForm.legal" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="schoolForm.contact" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="schoolForm.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="schoolForm.address" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateCommit" :loading="updateCommiting">确 定</el-button>
        <el-button @click="updateSchoolVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'school_list',
      pageSize: 0,
      companyList: [],
      searchForm: {
        company_ids: [],
        query: '',
        daterange: []
      },
      updateSchoolTitle: '',
      updateSchoolVisible: false,
      updateCommiting:false,
      schoolForm: {
        id: null,
        name: '',
        fullname: '',
        legal: '',
        contact: '',
        phone: '',
        address: '',
        name_pinyin: '',
        name_py: ''
      },
      modelType: ''
    }
  },
  computed: {
    schoolFormRules () {
      return {
        name: [
          { required: true, message: "请填写驾校全称", trigger: "blur" }
        ]
      }
    },
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          company_ids: this.searchForm.company_ids,
          query: this.searchForm.query,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    cleanForm () {
      this.schoolForm = {
        id: null,
        name: '',
        fullname: '',
        legal: '',
        contact: '',
        phone: '',
        address: '',
        name_pinyin: '',
        name_py: ''
      }
    },
    updateCommit () {
      let url = ''
      let postForm = {}
      if (this.modelType === '') { return false }
      if (this.modelType === 'add') {
        url = '/dbapi/insert_school'
        let addobj = this.schoolForm
        delete addobj.id
        postForm = addobj
        postForm.name_py = addobj.name
        postForm.name_pinyin = addobj.name
      } else {
        url = '/dbapi/update_school'
        postForm = this.schoolForm
      }
      this.$refs['schoolForm'].validate(valid => {
        if (valid) {
          if (this.modelType === 'add') {
            this.$http.get('/dbapi/school_info_byname?name=' + postForm.name).then(res => {
              if (res.data.success && res.data.list.length > 0) {
                this.$alert('已存在相同简称驾校，请检查是否重复添加或使用其他昵称', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    this.updateCommiting = false
                    return false
                  }
                })
              } else {
                this.postAction(url, postForm)
              }
            })
          } else {
            this.postAction(url, postForm)
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    addSchool () {
      this.modelType = 'add'
      this.updateSchoolTitle = '添加驾校信息'
      this.cleanForm()
      this.updateSchoolVisible = true
    },
    updateSchool (row) {
      this.modelType = 'update'
      this.updateSchoolTitle = `修改驾校：${row.name}`
      this.updateSchoolVisible = true
      this.schoolForm = {
        id: row.id,
        group_id: row.group_id,
        name: row.name,
        fullname: row.fullname,
        legal: row.legal,
        contact: row.contact,
        phone: row.phone,
        address: row.address,
        name_pinyin: row.name,
        name_py: row.name
      }
    },
    del (row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_school', { id: row.id }).then(res => {
          if (res.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: "error",
              message: "网络错误，请稍后重试"
            })
            console.log(res)
          }
        })
      })
    },
    postAction (url, postForm) {
      this.$http.post(url, postForm).then(res => {
        this.updateCommiting = false
        if (res.data.success) {
          this.cleanForm()
          this.refresh()
          this.updateSchoolVisible = false
          this.modelType = ""
        } else {
          this.$message({
            type: "error",
            message: response.data.message
          })
        }
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/data/School.vue